import EventElement from '../types/event-element';

const getActualId = <T extends EventElement>(element: T) => {
  return element.id;
};

export default getActualId;
